export const NOINDEX_TEST_HOSTS = new Set(['landing-test.veeso.ai']);

export function normalizeHost(host: string): string {
  return host.toLowerCase().split(':')[0];
}

export function isNoindexTestHost(host: string): boolean {
  return NOINDEX_TEST_HOSTS.has(normalizeHost(host));
}
